import {
  DoubleMaterialityESRSAreaEnum,
  DoubleMaterialityStakeholderESRSArea,
} from "@green0meter/api-client";
// import { DoubleMaterialityESRSArea } from "@green0meter/api-client/models/double-materiality-esrsarea"; // TODO figure out why this import breaks typecheck on CI
// TODO remove this once we figure out why the import breaks typecheck on CI
export enum DoubleMaterialityESRSArea {
  E1 = "E1",
  E2 = "E2",
  E3 = "E3",
  E4 = "E4",
  E5 = "E5",
  S1 = "S1",
  S2 = "S2",
  S3 = "S3",
  S4 = "S4",
  G1 = "G1",
  OTHER = "OTHER",
}

// ESRS types mapping (same as in StakeholdersTable)
export const ESRS_TYPES: Record<
  DoubleMaterialityStakeholderESRSArea | string,
  DoubleMaterialityESRSArea
> = {
  [DoubleMaterialityStakeholderESRSArea.ClimateChange]: DoubleMaterialityESRSArea.E1,
  [DoubleMaterialityStakeholderESRSArea.Pollution]: DoubleMaterialityESRSArea.E2,
  [DoubleMaterialityStakeholderESRSArea.WaterAndMarineSources]:
    DoubleMaterialityESRSArea.E3,
  [DoubleMaterialityStakeholderESRSArea.BiodiversityAndEcosystems]:
    DoubleMaterialityESRSArea.E4,
  [DoubleMaterialityStakeholderESRSArea.CircularEconomy]:
    DoubleMaterialityESRSArea.E5,
  [DoubleMaterialityStakeholderESRSArea.OwnWorkforce]: DoubleMaterialityESRSArea.S1,
  [DoubleMaterialityStakeholderESRSArea.WorkersInValueChain]:
    DoubleMaterialityESRSArea.S2,
  [DoubleMaterialityStakeholderESRSArea.AffectedCommunities]:
    DoubleMaterialityESRSArea.S3,
  [DoubleMaterialityStakeholderESRSArea.ConsumersAndEndUsers]:
    DoubleMaterialityESRSArea.S4,
  [DoubleMaterialityStakeholderESRSArea.BusinessConduct]:
    DoubleMaterialityESRSArea.G1,
  other: DoubleMaterialityESRSArea.OTHER,
} as const;

export const ESRS_STRING_TO_ENUM: Record<
  DoubleMaterialityESRSArea,
  DoubleMaterialityESRSAreaEnum | number
> = {
  [DoubleMaterialityESRSArea.E1]: DoubleMaterialityESRSAreaEnum.E1,
  [DoubleMaterialityESRSArea.E2]: DoubleMaterialityESRSAreaEnum.E2,
  [DoubleMaterialityESRSArea.E3]: DoubleMaterialityESRSAreaEnum.E3,
  [DoubleMaterialityESRSArea.E4]: DoubleMaterialityESRSAreaEnum.E4,
  [DoubleMaterialityESRSArea.E5]: DoubleMaterialityESRSAreaEnum.E5,
  [DoubleMaterialityESRSArea.S1]: DoubleMaterialityESRSAreaEnum.S1,
  [DoubleMaterialityESRSArea.S2]: DoubleMaterialityESRSAreaEnum.S2,
  [DoubleMaterialityESRSArea.S3]: DoubleMaterialityESRSAreaEnum.S3,
  [DoubleMaterialityESRSArea.S4]: DoubleMaterialityESRSAreaEnum.S4,
  [DoubleMaterialityESRSArea.G1]: DoubleMaterialityESRSAreaEnum.G1,
  [DoubleMaterialityESRSArea.OTHER]: 10,
} as const;

export const ESRS_ENUM_TO_STRING: Record<
  DoubleMaterialityESRSAreaEnum | number,
  DoubleMaterialityESRSArea
> = {
  [DoubleMaterialityESRSAreaEnum.E1]: DoubleMaterialityESRSArea.E1,
  [DoubleMaterialityESRSAreaEnum.E2]: DoubleMaterialityESRSArea.E2,
  [DoubleMaterialityESRSAreaEnum.E3]: DoubleMaterialityESRSArea.E3,
  [DoubleMaterialityESRSAreaEnum.E4]: DoubleMaterialityESRSArea.E4,
  [DoubleMaterialityESRSAreaEnum.E5]: DoubleMaterialityESRSArea.E5,
  [DoubleMaterialityESRSAreaEnum.S1]: DoubleMaterialityESRSArea.S1,
  [DoubleMaterialityESRSAreaEnum.S2]: DoubleMaterialityESRSArea.S2,
  [DoubleMaterialityESRSAreaEnum.S3]: DoubleMaterialityESRSArea.S3,
  [DoubleMaterialityESRSAreaEnum.S4]: DoubleMaterialityESRSArea.S4,
  [DoubleMaterialityESRSAreaEnum.G1]: DoubleMaterialityESRSArea.G1,
  10: DoubleMaterialityESRSArea.OTHER,
} as const;
// ESRS colors mapping (same as in Chip.styled.tsx)
export const ESRS_COLORS: Record<
  string,
  { background: string; border: string; color: string }
> = {
  E1: { background: "#C6E0FF", border: "#67ACFF", color: "#065CC4" },
  E2: { background: "#E9EBFB", border: "#C7CCF6", color: "#1E3FC7" },
  E3: { background: "#F9F5FF", border: "#E9D7FE", color: "#6941C6" },
  E4: { background: "#E2F4F2", border: "#B7E3DD", color: "#269483" },
  E5: { background: "#F3E4FF", border: "#E3C2FE", color: "#A66AD7" },
  S1: { background: "#E6F5ED", border: "#C4E5D2", color: "#2B8B58" },
  S2: { background: "#FEF9C3", border: "#FDE047", color: "#854D0E" },
  S3: { background: "#FCFCFC", border: "#E9E9E9", color: "#555555" },
  S4: { background: "#EDD9CF", border: "#D6AB97", color: "#AE7054" },
  G1: { background: "#FFF4E4", border: "#FFDBB8", color: "#F57C00" },
  OTHER: { background: "#F2F2F2", border: "#BFBFBF", color: "#555555" },
};
